// MALAWİ + TANGANYİKA CİKLETLERİ - balikVeritabani2.js
// Wikipedia Commons ücretsiz resimler kullanılmıştır

export const malawiCikletleri = {
  kategori: {
    id: 'malawi-cikletleri',
    isim: 'Malawi Cikletleri',
    emoji: '🐠',
    renk: '#3498db',
    aciklama: 'Afrika Malawi Gölü cikletleri - Mbuna, Peacock, Hap grupları'
  },
  baliklar: [
    {
      id: 'yellow-lab',
      isim: 'Yellow Lab (Sarı Prenses)',
      latince: 'Labidochromis caeruleus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Labidochromis_caeruleus_male.jpg/1280px-Labidochromis_caeruleus_male.jpg',
      zorluk: 'Kolay',
      genel: 'Malawi gölünün en popüler ve barışçıl Mbuna türü. Parlak sarı rengi ve nispeten sakin yapısıyla topluluk Malawi tanklarında ideal. Başlangıç seviyesi için önerilir.',
      minLitre: 150,
      maxBoy: 10,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '6-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor - Spirulina bazlı yem, ciklet peleti. Fazla protein vermekten kaçının (Malawi bloat riski).',
      uyumlu: ['Diğer barışçıl Mbuna', 'Peacock türleri', 'Synodontis'],
      uyumsuz: ['Çok agresif Mbuna', 'Benzer sarı renkli türler'],
      ureme: 'Ağız kuluçkacı. Dişi 20-30 yumurtayı ağzında 21 gün taşır.',
      eslesme: 'Erkek bölge savunur, dişiyi kur yapar. Dişi yumurtaları alır ve ağzında döller.',
      grupSayisi: '1 erkek / 3-4 dişi',
      disiErkek: 'Harem grubu önerilir. Tek erkek, birden fazla dişi.',
      gorunus: 'Elektrik sarısı vücut. Yüzgeçlerde siyah kenar çizgisi. Erkek ve dişi benzer görünür ama erkekler biraz daha parlak.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'demasoni',
      isim: 'Demasoni',
      latince: 'Pseudotropheus demasoni',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Pseudotropheus_demasoni.jpg/1280px-Pseudotropheus_demasoni.jpg',
      zorluk: 'Zor',
      genel: 'Küçük ama son derece agresif Mbuna. Pombo Rocks bölgesine endemik. Çok dar bir alanda yaşar, bu yüzden son derece territorial.',
      minLitre: 200,
      maxBoy: 8,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Herbivor - Sadece bitkisel yem. Spirulina, alg tabletleri.',
      uyumlu: ['Diğer agresif Mbuna', 'Farklı desenli türler'],
      uyumsuz: ['Benzer mavi çizgili türler', 'Barışçıl balıklar', 'Yavaş türler'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Çok agresif üreme davranışı.',
      grupSayisi: '12+ (agresyonu dağıtmak için)',
      disiErkek: 'Büyük grup şart. 1 erkek / 4-5 dişi veya tüm erkek grubu.',
      gorunus: 'Koyu mavi-siyah üzerinde açık mavi/beyaz dikey çizgiler. Zebra deseni. Erkek ve dişi aynı görünür.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'red-zebra',
      isim: 'Red Zebra',
      latince: 'Maylandia estherae',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Metriaclima_estherae.jpg/1280px-Metriaclima_estherae.jpg',
      zorluk: 'Orta',
      genel: 'Popüler Mbuna türü. Doğada erkekler mavi, dişiler turuncu. Akvaryumda OB (turuncu blotch) formları yaygın.',
      minLitre: 200,
      maxBoy: 13,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Herbivor - Spirulina, alg, sebze.',
      uyumlu: ['Diğer Mbuna', 'Synodontis'],
      uyumsuz: ['Çok benzer türler', 'Barışçıl balıklar'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Erkek T şeklinde kur yapar.',
      grupSayisi: '1 erkek / 3-4 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Erkekler açık mavi, dişiler turuncu-kırmızı (doğada). Akvaryumda her iki cinsiyet turuncu olabilir. OB formunda turuncu üzerinde siyah benekler.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'kenyi',
      isim: 'Kenyi',
      latince: 'Maylandia lombardoi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Maylandia_lombardoi.jpg/1280px-Maylandia_lombardoi.jpg',
      zorluk: 'Orta',
      genel: 'İlginç renk değişimi gösteren Mbuna. Genç ve dişiler mavi-siyah çizgili, yetişkin erkekler sarıya döner.',
      minLitre: 200,
      maxBoy: 13,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Herbivor - Bitkisel ağırlıklı.',
      uyumlu: ['Diğer Mbuna'],
      uyumsuz: ['Sarı renkli türler', 'Barışçıl balıklar'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Agresif erkekler.',
      grupSayisi: '1 erkek / 4 dişi',
      disiErkek: 'Harem grubu şart.',
      gorunus: 'Dişiler ve gençler: Mavi-siyah dikey çizgiler. Yetişkin erkekler: Altın sarısı vücut, soluk çizgiler.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'socolofi',
      isim: 'Socolofi (Pindani)',
      latince: 'Pseudotropheus socolofi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Pseudotropheus_socolofi.jpg/1280px-Pseudotropheus_socolofi.jpg',
      zorluk: 'Orta',
      genel: 'Powder Blue Cichlid olarak da bilinir. Güzel mavi rengi ve orta düzey agresyonu ile popüler.',
      minLitre: 200,
      maxBoy: 12,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor - Spirulina ağırlıklı.',
      uyumlu: ['Diğer Mbuna', 'Peacock türleri'],
      uyumsuz: ['Benzer mavi türler'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Standart Mbuna davranışı.',
      grupSayisi: '1 erkek / 3 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Toz mavisi vücut, tüm vücut uniform renkte. Yüzgeçlerde hafif siyah kenar.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'acei',
      isim: 'Acei',
      latince: 'Pseudotropheus acei',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Pseudotropheus_sp_acei.jpg/1280px-Pseudotropheus_sp_acei.jpg',
      zorluk: 'Kolay',
      genel: 'Yellow-tail Acei olarak bilinir. En barışçıl Mbuna türlerinden biri. Odun ve kayalık bölgelerde yaşar.',
      minLitre: 200,
      maxBoy: 15,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta',
      beslenme: 'Herbivor - Odun üzerindeki alg, spirulina.',
      uyumlu: ['Diğer barışçıl Mbuna', 'Peacock', 'Hap türleri'],
      uyumsuz: ['Çok agresif türler'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Nispeten sakin üreme.',
      grupSayisi: '6+ (sürü balığı gibi)',
      disiErkek: 'Grup halinde daha iyi.',
      gorunus: 'Mavi-mor vücut, parlak sarı kuyruk ve sırt yüzgeci. Her iki cins benzer.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'auratus',
      isim: 'Auratus',
      latince: 'Melanochromis auratus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Melanochromis_auratus_male.jpg/1280px-Melanochromis_auratus_male.jpg',
      zorluk: 'Zor',
      genel: 'Golden Mbuna. Dramatik renk değişimi. Dişiler altın sarısı, erkekler siyah-mavi. EN agresif Mbuna türlerinden biri!',
      minLitre: 250,
      maxBoy: 12,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '5-8 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Herbivor - Spirulina, alg.',
      uyumlu: ['Sadece çok agresif Mbuna'],
      uyumsuz: ['Çoğu balık türü', 'Barışçıl türler', 'Benzer desenli türler'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Aşırı agresif erkekler. Dişileri öldürebilir.',
      grupSayisi: '1 erkek / 5+ dişi',
      disiErkek: 'Çok sayıda dişi şart.',
      gorunus: 'Dişiler: Altın sarısı üzerinde siyah-beyaz yatay çizgiler. Erkekler: Siyah-koyu mavi üzerinde açık mavi çizgiler (renk tersine döner).',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'cobalt-zebra',
      isim: 'Cobalt Blue Zebra',
      latince: 'Maylandia callainos',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Maylandia_callainos.jpg/1280px-Maylandia_callainos.jpg',
      zorluk: 'Orta',
      genel: 'Parlak kobalt mavisi ile tanınır. Popüler ve nispeten dayanıklı Mbuna türü.',
      minLitre: 200,
      maxBoy: 12,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Herbivor - Spirulina bazlı yemler.',
      uyumlu: ['Diğer Mbuna'],
      uyumsuz: ['Benzer mavi türler'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Standart Mbuna davranışı.',
      grupSayisi: '1 erkek / 3-4 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Uniform parlak kobalt mavisi. Erkeklerde 4-7 yumurta lekesi anal yüzgeçte.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'peacock-sunshine',
      isim: 'Sunshine Peacock',
      latince: 'Aulonocara stuartgranti',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Aulonocara_stuartgranti.jpg/1280px-Aulonocara_stuartgranti.jpg',
      zorluk: 'Orta',
      genel: 'Peacock türlerinin en renklilerinden. Lokasyona göre farklı renk varyasyonları mevcut. Mbuna\'dan daha barışçıl.',
      minLitre: 200,
      maxBoy: 15,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor - Yüksek proteinli yem kabul eder. Ciklet peleti, dondurulmuş yem.',
      uyumlu: ['Diğer Peacock türleri', 'Barışçıl Hap', 'Barışçıl Mbuna'],
      uyumsuz: ['Agresif Mbuna', 'Benzer renkli Peacock'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Erkek kumda çukur kazar ve dişiyi çağırır.',
      grupSayisi: '1 erkek / 3-4 dişi',
      disiErkek: 'Harem grubu. Farklı Peacock türleri melezlenebilir - dikkat!',
      gorunus: 'Parlak sarı-turuncu vücut, mavi yüz ve başlık. Usisya varyasyonu en parlak sarı. Dişiler gümüşi-kahverengi.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'peacock-blue',
      isim: 'Blue Peacock (Nyassae)',
      latince: 'Aulonocara nyassae',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Aulonocara_nyassae.jpg/1280px-Aulonocara_nyassae.jpg',
      zorluk: 'Orta',
      genel: 'Emperor Cichlid olarak da bilinir. İlk tanımlanan Peacock türü. Metalik mavi renkleriyle etkileyici.',
      minLitre: 200,
      maxBoy: 18,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor - Protein tolere eder.',
      uyumlu: ['Diğer Peacock', 'Barışçıl Hap'],
      uyumsuz: ['Agresif Mbuna'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Standart Peacock davranışı.',
      grupSayisi: '1 erkek / 3-4 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Metalik mavi vücut, özellikle yüz bölgesi çok parlak. 9-11 dikey koyu çizgi. Dişiler gri-kahverengi.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'peacock-ruby-red',
      isim: 'Ruby Red Peacock',
      latince: 'Aulonocara rubescens',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Aulonocara_Red.jpg/1280px-Aulonocara_Red.jpg',
      zorluk: 'Orta',
      genel: 'Parlak kırmızı rengiyle çok popüler. Selektif üretimle elde edilmiş renk formu. Gerçek doğal türden daha renkli.',
      minLitre: 200,
      maxBoy: 15,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Peacock türleri', 'Barışçıl Hap'],
      uyumsuz: ['Agresif Mbuna'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Standart Peacock davranışı.',
      grupSayisi: '1 erkek / 3-4 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Parlak kırmızı-turuncu vücut, mavi yüz tonları. Çok gösterişli.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'peacock-ob',
      isim: 'OB Peacock',
      latince: 'Aulonocara sp. "OB"',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/OB_Peacock_Cichlid.jpg/1280px-OB_Peacock_Cichlid.jpg',
      zorluk: 'Orta',
      genel: 'Orange Blotch deseni - Mbuna ile Peacock melezi. Her birey farklı desenli olabilir. Akvaryum oluşturulmuş form.',
      minLitre: 200,
      maxBoy: 15,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Peacock türleri', 'Bazı Hap türleri'],
      uyumsuz: ['Agresif Mbuna'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Standart Peacock davranışı.',
      grupSayisi: '1 erkek / 3-4 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Turuncu, mavi, siyah karışımı benekli desen. Her birey benzersiz. OB = Orange Blotch.',
      kaynaklar: ['cichlid-forum.com']
    },
    {
      id: 'electric-blue-hap',
      isim: 'Electric Blue Hap',
      latince: 'Sciaenochromis fryeri',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Sciaenochromis_fryeri.jpg/1280px-Sciaenochromis_fryeri.jpg',
      zorluk: 'Orta',
      genel: 'Electric Blue Ahli olarak da bilinir. Erkeklerin elektrik mavisi rengi muhteşemdir. Piscivore (balık yiyici) ama orta boy.',
      minLitre: 300,
      maxBoy: 18,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta',
      beslenme: 'Karnivor - Yüksek proteinli yem, balık eti, karides.',
      uyumlu: ['Diğer Hap türleri', 'Büyük Peacock'],
      uyumsuz: ['Küçük balıklar (yer)', 'Benzer mavi türler'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Erkek bölge savunur.',
      grupSayisi: '1 erkek / 2-3 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Erkekler: Elektrik mavisi tüm vücut, beyaz blaze (alın çizgisi). Dişiler: Gümüşi-gri, soluk çizgiler.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'venustus',
      isim: 'Venustus (Giraffe Hap)',
      latince: 'Nimbochromis venustus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Nimbochromis_venustus.jpg/1280px-Nimbochromis_venustus.jpg',
      zorluk: 'Orta',
      genel: 'Zürafa deseni ile tanınır. Büyük predatör, küçük balıkları yer. Kumda yatıp ölü taklidi yaparak avlanır.',
      minLitre: 400,
      maxBoy: 25,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Alt ve Orta',
      beslenme: 'Karnivor - Balık, karides, yüksek protein.',
      uyumlu: ['Diğer büyük Hap türleri'],
      uyumsuz: ['Küçük tüm balıklar', 'Mbuna'],
      ureme: 'Ağız kuluçkacı. Dişi 100+ yumurta taşıyabilir.',
      eslesme: 'Büyük kumlu alan gerekir.',
      grupSayisi: '1 erkek / 2-3 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Sarı-kahverengi üzerinde koyu kahve zürafa deseni. Erkekler yaşlandıkça mavi yüz ve alın geliştirir.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'livingstonii',
      isim: 'Livingstonii',
      latince: 'Nimbochromis livingstonii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Nimbochromis_livingstonii.jpg/1280px-Nimbochromis_livingstonii.jpg',
      zorluk: 'Orta',
      genel: 'Sleeper - ölü taklidi yapan avcı. Dibe yatar, soluk renklenir, küçük balıklar yaklaşınca saldırır.',
      minLitre: 400,
      maxBoy: 25,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor - Balık, canlı yem.',
      uyumlu: ['Diğer büyük Hap türleri'],
      uyumsuz: ['Küçük tüm balıklar'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Standart büyük Hap davranışı.',
      grupSayisi: '1 erkek / 2-3 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Gümüşi-beyaz üzerinde büyük düzensiz kahverengi-siyah lekeler. Erkekler mavi tonlar geliştirir.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'compressiceps-malawi',
      isim: 'Malawi Eyebiter',
      latince: 'Dimidiochromis compressiceps',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Dimidiochromis_compressiceps.jpg/1280px-Dimidiochromis_compressiceps.jpg',
      zorluk: 'Zor',
      genel: 'Yanal olarak sıkıştırılmış vücut. Doğada diğer balıkların gözlerini yerdiği söylenir (Eyebiter adı buradan).',
      minLitre: 400,
      maxBoy: 25,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta',
      beslenme: 'Karnivor - Balık, yüksek protein.',
      uyumlu: ['Diğer büyük predatör Hap'],
      uyumsuz: ['Tüm küçük balıklar', 'Mbuna'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Erkek agresif olabilir.',
      grupSayisi: '1 erkek / 2 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Yan yassı (kompres) vücut. Metalik mavi-yeşil. Uzun sivri burun. Erkekler çok parlak mavi.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'taiwan-reef',
      isim: 'Taiwan Reef',
      latince: 'Protomelas sp. "Steveni Taiwan"',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Taiwan_Reef_Cichlid.jpg/1280px-Taiwan_Reef_Cichlid.jpg',
      zorluk: 'Orta',
      genel: 'Güzel kırmızı-mavi renk kombinasyonu. Taiwanee Reef olarak da bilinir. Hap grubundan.',
      minLitre: 300,
      maxBoy: 18,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Dengeli diyet.',
      uyumlu: ['Diğer Hap', 'Peacock türleri'],
      uyumsuz: ['Agresif Mbuna', 'Küçük balıklar'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Standart Hap davranışı.',
      grupSayisi: '1 erkek / 3 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Erkekler: Mavi kafa, kırmızı-turuncu vücut. Çok çekici renk kombinasyonu. Dişiler gri-kahverengi.',
      kaynaklar: ['cichlid-forum.com']
    },
    {
      id: 'red-empress',
      isim: 'Red Empress',
      latince: 'Protomelas taeniolatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Protomelas_taeniolatus_Red.jpg/1280px-Protomelas_taeniolatus_Red.jpg',
      zorluk: 'Orta',
      genel: 'Spindle Hap olarak da bilinir. Erkekler kırmızı-mavi renk kombinasyonu ile çok gösterişli.',
      minLitre: 300,
      maxBoy: 18,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.8, max: 8.6 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Alg ve protein karışımı.',
      uyumlu: ['Peacock', 'Diğer Hap', 'Barışçıl Mbuna'],
      uyumsuz: ['Çok agresif türler'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Nispeten barışçıl.',
      grupSayisi: '1 erkek / 3 dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'Erkekler: Mavi baş ve yüzgeçler, kırmızı-turuncu vücut. Dişiler: Gümüşi, yatay çizgiler.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    }
  ]
};

export const tanganyikaCikletleri = {
  kategori: {
    id: 'tanganyika-cikletleri',
    isim: 'Tanganyika Cikletleri',
    emoji: '🐡',
    renk: '#9b59b6',
    aciklama: 'Afrika Tanganyika Gölü cikletleri - Benzersiz davranışlar ve şekiller'
  },
  baliklar: [
    {
      id: 'frontosa',
      isim: 'Frontosa',
      latince: 'Cyphotilapia frontosa',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Cyphotilapia_frontosa.jpg/1280px-Cyphotilapia_frontosa.jpg',
      zorluk: 'Orta',
      genel: 'Tanganyika\'nın kralı. Büyük baş çıkıntısı (nuchal hump) ile tanınır. Yavaş büyür ama çok uzun yaşar. Derin su balığı.',
      minLitre: 500,
      maxBoy: 35,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 25 },
      yasam: '15-25 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Karnivor - Balık, karides, yüksek protein peleti.',
      uyumlu: ['Diğer büyük Tanganyika türleri', 'Büyük Synodontis'],
      uyumsuz: ['Küçük balıklar', 'Agresif türler', 'Malawi cikletleri'],
      ureme: 'Ağız kuluçkacı. Dişi 50+ yumurtayı 4-5 hafta taşır.',
      eslesme: 'Yavaş, sakin üreme. Haremi vardır.',
      grupSayisi: '1 erkek / 4+ dişi',
      disiErkek: 'Harem grubu. Erkeklerin baş çıkıntısı daha büyük.',
      gorunus: 'Mavi-beyaz veya siyah-beyaz dikey bantlar (6-7 bant). Büyük baş çıkıntısı. Burundi (6 bant), Zaire (7 bant) gibi lokasyon varyantları var.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'tropheus-duboisi',
      isim: 'Tropheus Duboisi',
      latince: 'Tropheus duboisi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Tropheus_duboisi.jpg/1280px-Tropheus_duboisi.jpg',
      zorluk: 'Zor',
      genel: 'White Spotted Cichlid. Gençler siyah üzerinde beyaz noktalı, yetişkinler mavi bantlı. Çok özel su gereksinimleri.',
      minLitre: 300,
      maxBoy: 12,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta',
      beslenme: 'Herbivor - SADECE bitkisel! Spirulina, alg. Protein Tropheus bloat\'a neden olur.',
      uyumlu: ['Diğer Tropheus (aynı tür)', 'Petrochromis'],
      uyumsuz: ['Farklı Tropheus türleri (melezlenir)', 'Protein yiyen türler'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Koloni halinde tutulmalı.',
      grupSayisi: '12+ (agresyonu dağıtmak için)',
      disiErkek: 'Büyük koloni, cinsiyet oranı önemli değil.',
      gorunus: 'Gençler: Siyah vücut, beyaz noktalar. Yetişkinler: Siyah vücut ortasında geniş sarı-beyaz dikey bant.',
      kaynaklar: ['fishbase.org', 'tropheus.info']
    },
    {
      id: 'tropheus-moorii',
      isim: 'Tropheus Moorii',
      latince: 'Tropheus moorii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Tropheus_moorii.jpg/1280px-Tropheus_moorii.jpg',
      zorluk: 'Zor',
      genel: 'Blunthead Cichlid. 100\'den fazla renk varyasyonu. Lokasyona göre çok farklı renkler. Koloni hayvanı.',
      minLitre: 300,
      maxBoy: 14,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 25 },
      yasam: '8-10 yıl',
      bolge: 'Orta',
      beslenme: 'Herbivor - Kesinlikle bitkisel. Spirulina şart.',
      uyumlu: ['Aynı varyasyon Tropheus'],
      uyumsuz: ['Farklı Tropheus varyasyonları', 'Protein yiyen türler'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Koloni üremesi.',
      grupSayisi: '15-20+',
      disiErkek: 'Büyük koloni şart.',
      gorunus: 'Çok sayıda renk formu: Red Rainbow, Bemba, Ikola, Murago, Mpimbwe vb. Kırmızı, sarı, yeşil, turuncu renklerde.',
      kaynaklar: ['fishbase.org', 'tropheus.info']
    },
    {
      id: 'neolamprologus-brichardi',
      isim: 'Princess of Burundi (Brichardi)',
      latince: 'Neolamprologus brichardi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Neolamprologus_brichardi.jpg/1280px-Neolamprologus_brichardi.jpg',
      zorluk: 'Orta',
      genel: 'Fairy Cichlid. Zarif lir kuyruk ve yüzgeç uzantıları. Aile grupları halinde yaşar, yavrular ebeveynlere yardım eder.',
      minLitre: 150,
      maxBoy: 10,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor - Küçük canlı yem, pul yem, pellet.',
      uyumlu: ['Diğer Neolamprologus', 'Cyprichromis', 'Julidochromis'],
      uyumsuz: ['Dip yaşayan küçük balıklar (saldırır)'],
      ureme: 'Substrat yumurtlayıcı. Mağarada yumurta bırakır.',
      eslesme: 'Çift bağı kurar. Önceki nesil yavrular ebeveynlere bakımda yardım eder (cooperative breeding).',
      grupSayisi: 'Çift veya koloni',
      disiErkek: '1 çift ile başlanabilir, koloni oluşur.',
      gorunus: 'Zarif krem-bej vücut. Yüzgeç kenarlarında mavi-beyaz ipliksi uzantılar. Kuyruk lir şeklinde. Yanakta siyah çizgi.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'neolamprologus-leleupi',
      isim: 'Lemon Cichlid (Leleupi)',
      latince: 'Neolamprologus leleupi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Neolamprologus_leleupi.jpg/1280px-Neolamprologus_leleupi.jpg',
      zorluk: 'Orta',
      genel: 'Parlak limon sarısı veya turuncu rengiyle popüler. Kayalık bölgelerde yaşar. Agresif olabilir.',
      minLitre: 150,
      maxBoy: 10,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Karnivor - Canlı yem, dondurulmuş yem, karnivor peleti.',
      uyumlu: ['Diğer Tanganyika türleri (farklı bölge kullanan)'],
      uyumsuz: ['Benzer büyüklükte dip balıkları', 'Yavaş türler'],
      ureme: 'Substrat yumurtlayıcı. Mağarada.',
      eslesme: 'Çift kurar, mağara savunur.',
      grupSayisi: '1 çift',
      disiErkek: 'Çift halinde.',
      gorunus: 'Uniform parlak sarı veya turuncu. Lokasyona göre renk yoğunluğu değişir.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'julidochromis-marlieri',
      isim: 'Marlieri',
      latince: 'Julidochromis marlieri',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Julidochromis_marlieri.jpg/1280px-Julidochromis_marlieri.jpg',
      zorluk: 'Orta',
      genel: 'Checkered Julie. Damalı deseniyle tanınır. Kayalık yarıklarda yaşar.',
      minLitre: 100,
      maxBoy: 13,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '5-8 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Küçük canlı yem, pul yem.',
      uyumlu: ['Diğer Julidochromis', 'Neolamprologus', 'Cyprichromis'],
      uyumsuz: ['Aynı tür (çift harici)'],
      ureme: 'Substrat yumurtlayıcı. Yarıklarda.',
      eslesme: 'Güçlü çift bağı. Aynı cins kardeşleri reddeder.',
      grupSayisi: '1 çift',
      disiErkek: 'Sadece bağlanmış çift.',
      gorunus: 'Krem-beyaz üzerinde siyah-kahverengi damalı/kareli desen. Uzun silindirik vücut.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'julidochromis-regani',
      isim: 'Regani',
      latince: 'Julidochromis regani',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Julidochromis_regani.jpg/1280px-Julidochromis_regani.jpg',
      zorluk: 'Kolay',
      genel: 'Convict Julie. Yatay çizgili. Julidochromis türlerinin en büyüğü ve en kolay bakılanı.',
      minLitre: 120,
      maxBoy: 15,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '8-10 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Tanganyika türleri'],
      uyumsuz: ['Aynı tür (çift harici)'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Çift bağı.',
      grupSayisi: '1 çift',
      disiErkek: 'Çift halinde.',
      gorunus: 'Krem vücut üzerinde koyu yatay çizgiler. Sarımsı yüzgeç kenarları.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'altolamprologus-calvus',
      isim: 'Calvus',
      latince: 'Altolamprologus calvus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Altolamprologus_calvus.jpg/1280px-Altolamprologus_calvus.jpg',
      zorluk: 'Orta',
      genel: 'Yan yassı vücut - dar yarıklara girebilmek için evrimleşmiş. Salyangoz kabukları ve yarıklardan yiyecek çalar.',
      minLitre: 150,
      maxBoy: 14,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '8-10 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor - Canlı ve dondurulmuş yem.',
      uyumlu: ['Diğer Tanganyika (farklı niş)'],
      uyumsuz: ['Benzer türler', 'Küçük balıklar'],
      ureme: 'Substrat yumurtlayıcı. Yarık veya kabukta.',
      eslesme: 'Yavaş üreme.',
      grupSayisi: '1 erkek / 2 dişi',
      disiErkek: 'Harem mümkün.',
      gorunus: 'Aşırı yan yassı vücut. Siyah, beyaz veya sarı varyantları var. Dikey koyu bantlar.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'altolamprologus-compressiceps',
      isim: 'Compressiceps',
      latince: 'Altolamprologus compressiceps',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Altolamprologus_compressiceps.jpg/1280px-Altolamprologus_compressiceps.jpg',
      zorluk: 'Orta',
      genel: 'Calvus\'a benzer ama daha büyük ve daha agresif. Aynı dar vücut adaptasyonu.',
      minLitre: 200,
      maxBoy: 15,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '8-10 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor',
      uyumlu: ['Büyük Tanganyika türleri'],
      uyumsuz: ['Küçük balıklar', 'Benzer türler'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Çift veya harem.',
      grupSayisi: '1 erkek / 1-2 dişi',
      disiErkek: 'Erkekler çok daha büyük.',
      gorunus: 'Calvus\'a benzer yan yassı vücut. Gold Head, Red Fin gibi lokasyon varyantları.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'cyprichromis-leptosoma',
      isim: 'Cyprichromis',
      latince: 'Cyprichromis leptosoma',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Cyprichromis_leptosoma.jpg/1280px-Cyprichromis_leptosoma.jpg',
      zorluk: 'Orta',
      genel: 'Sardine Cichlid. Açık suda sürü halinde yaşar. Tanganyika\'nın nadir açık su cikletlerinden.',
      minLitre: 300,
      maxBoy: 12,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '8-10 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor - Zooplankton, pul yem, küçük pellet.',
      uyumlu: ['Çoğu Tanganyika türü'],
      uyumsuz: ['Agresif açık su avcıları'],
      ureme: 'Ağız kuluçkacı. Açık suda ürer.',
      eslesme: 'Sürü içinde üreme.',
      grupSayisi: '12+ (sürü balığı)',
      disiErkek: 'Büyük sürü.',
      gorunus: 'İnce, uzun vücut. Erkekler sarı veya mavi kuyruklu. Blue Flash, Yellow Tail gibi formlar.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'lamprologus-ocellatus',
      isim: 'Kabuk Ciklet (Ocellatus)',
      latince: 'Lamprologus ocellatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Lamprologus_ocellatus.jpg/1280px-Lamprologus_ocellatus.jpg',
      zorluk: 'Kolay',
      genel: 'Shell dweller - salyangoz kabuklarında yaşar. Çok küçük ama cesur ve teritoryal.',
      minLitre: 60,
      maxBoy: 5,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '5-8 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor - Küçük canlı ve dondurulmuş yem.',
      uyumlu: ['Diğer kabuk cikletleri (farklı tür)', 'Açık su türleri'],
      uyumsuz: ['Büyük dip balıkları'],
      ureme: 'Kabukta yumurtlar.',
      eslesme: 'Kabuk savunması. Erkek birden fazla kabuk/dişi kontrol edebilir.',
      grupSayisi: '1 erkek / 2-3 dişi + kabuklar',
      disiErkek: 'Harem mümkün.',
      gorunus: 'Küçük, kahverengimsi vücut. Göz kenarında mavi yansıma (ocel). Gold varyasyonu sarı.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    },
    {
      id: 'neolamprologus-multifasciatus',
      isim: 'Multies',
      latince: 'Neolamprologus multifasciatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Neolamprologus_multifasciatus.jpg/1280px-Neolamprologus_multifasciatus.jpg',
      zorluk: 'Kolay',
      genel: 'Dünyanın en küçük ciklet türlerinden. Kabuk kolonileri kurar. Nano Tanganyika tankı için ideal.',
      minLitre: 40,
      maxBoy: 4,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '5-8 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Küçük yemler.',
      uyumlu: ['Diğer küçük kabuk türleri', 'Cyprichromis'],
      uyumsuz: ['Büyük balıklar'],
      ureme: 'Kabukta yumurtlar. Koloni oluşur.',
      eslesme: 'Aile kolonisi kurulur.',
      grupSayisi: '6+',
      disiErkek: 'Koloni.',
      gorunus: 'Çok küçük. Soluk kahverengi-gri vücut, çok sayıda dikey çizgi (multifasciatus = çok çizgili).',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'xenotilapia-flavipinnis',
      isim: 'Yellow Sand Cichlid',
      latince: 'Xenotilapia flavipinnis',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Xenotilapia_flavipinnis.jpg/1280px-Xenotilapia_flavipinnis.jpg',
      zorluk: 'Orta',
      genel: 'Kumda beslenen goby benzeri ciklet. Sarı yüzgeçleriyle çekici. Topluluk Tanganyika tankı için iyi.',
      minLitre: 200,
      maxBoy: 9,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '5-8 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Kum eleyerek beslenme. Küçük organizmalar, dondurulmuş yem.',
      uyumlu: ['Diğer Tanganyika türleri'],
      uyumsuz: ['Agresif dip türleri'],
      ureme: 'Çift kuluçkacı - her iki ebeveyn ağzında taşır.',
      eslesme: 'Benzersiz çift kuluçkalama davranışı.',
      grupSayisi: '6+',
      disiErkek: 'Grup.',
      gorunus: 'İnce, uzun vücut. Gümüşi-bej renk. Parlak sarı yüzgeçler.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'cyphotilapia-gibberosa',
      isim: 'Blue Frontosa (Zaire)',
      latince: 'Cyphotilapia gibberosa',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Cyphotilapia_gibberosa.jpg/1280px-Cyphotilapia_gibberosa.jpg',
      zorluk: 'Orta',
      genel: 'Güney Tanganyika\'dan. C. frontosa\'dan ayrılmış tür. 7 bant ile tanınır. Daha mavi tonlar.',
      minLitre: 500,
      maxBoy: 35,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 8.0, max: 9.0 },
      sertlik: { min: 10, max: 25 },
      yasam: '15-25 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Karnivor - C. frontosa ile aynı.',
      uyumlu: ['Büyük Tanganyika türleri'],
      uyumsuz: ['Küçük balıklar', 'Malawi cikletleri'],
      ureme: 'Ağız kuluçkacı.',
      eslesme: 'Harem.',
      grupSayisi: '1 erkek / 4+ dişi',
      disiErkek: 'Harem grubu.',
      gorunus: 'C. frontosa\'ya çok benzer ama 7 bant (frontosa 6). Daha yoğun mavi renk.',
      kaynaklar: ['fishbase.org', 'cichlid-forum.com']
    }
  ]
};

export default { malawiCikletleri, tanganyikaCikletleri };